// RadialBarChart.tsx
import { Doughnut } from "react-chartjs-2";
import {Chart as ChartJS,ArcElement,Tooltip,Legend,ChartOptions,ChartData,} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

interface RadialChartProps {
  value: number; 
  label?: string;
  color?: string;
}

/**
 * RadialBarChart
 *
 * نمایش نمودار دایره‌ای (Donut) با مقدار درصدی.
 * این کامپوننت برای نمایش مقدار بین 0 تا 100 مناسب است و دارای:
 * - رنگ سفارشی برای مقدار پر شده
 * - نمایش برچسب در مرکز نمودار
 * - کاملاً واکنش‌گرا برای موبایل، تبلت و دسکتاپ
 *
 * @param value - مقدار عددی بین 0 تا 100 برای پر کردن نمودار
 * @param label - برچسب مرکز نمودار (اختیاری، پیش‌فرض: "درصد")
 * @param color - رنگ نمودار پر شده (اختیاری، پیش‌فرض: "#A90000")
 * @returns JSX.Element
 */

function RadialBarChart(props: RadialChartProps) {
  const { value, label = "درصد", color = "#A90000" } = props;

  const data: ChartData<"doughnut"> = {
    labels: [label, ""],
    datasets: [
      {
        data: [value, 100 - value],
        backgroundColor: [color, "#0c0a0aff"],
        borderWidth: 0,
      },
    ],
  };

  const options: ChartOptions<"doughnut"> = {
    responsive: true,
    maintainAspectRatio: true,
    cutout: "79%",
    plugins: {
      tooltip: {
        enabled: false,
      },
      legend: {
        display: false,
      },
    },
  };

  return (
    <div style={{position: "relative",width: "100%",maxWidth: 300,aspectRatio: "1 / 1",margin: "0 auto",}}>
      <div style={{position: "absolute",top: "50%",left: "50%",transform: "translate(-50%, -50%)",textAlign: "center",color: "#fff",fontSize: "clamp(12px, 1.5vw, 16px)", }}>
        {label}
      </div>
      <Doughnut data={data} options={options} />
    </div>
  );
}

export default RadialBarChart;
